import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SearchService {
  private searchData: any;
  constructor() {}
  setSearchData(data: any) {
    this.resetSearchData();
    this.searchData = data;
  }

  getSearchData(): any {
    console.log(this.searchData);
    return this.searchData;
  }
  resetSearchData() {
    this.searchData = null;
    console.log('reset: ',this.searchData);
  }
}
